<div class="col-lg-12 mb-3">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3 mb-0">
        <span class="col-auto">
          <h2 class="mb-0">Year To Date Summary</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button label=" Clear Filters" (click)="clearTable(dt)" />
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12 p-3">
        <p-table
          #dt
          stripedRows
          scrollHeight="calc(100vh - 310px)"
          responsiveLayout="scroll"
          [value]="yearToDateSummaryLists"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="yearToDateSummaryLists.length >= 20"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [size]="'small'"
          [resizableColumns]="true"
          styleClass="table-listing p-datatable-customers p-head-pad">
          <!-- <ng-template pTemplate="caption" *ngIf="!isFromDashboard">
            
            <p-button label=" Clear Filters" (click)="clearTable(dt)">
          </ng-template> -->
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th pSortableColumn="YTGP">
                {{
                  isFromDashboard
                    ? isFromBcReport
                      ? "FY GP $"
                      : "12 Months GP$"
                    : "YTD-GP$"
                }}
                <p-sortIcon field="YTGP"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="YTGP"
                  display="menu"></p-columnFilter>
              </th>
              <th
                style="width: 6rem"
                pSortableColumn="rollingTwelveMonthGp"
                *ngIf="isFromDashboard">
                Rolling 12 Month GP $
                <p-sortIcon field="rollingTwelveMonthGp"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="rollingTwelveMonthGp"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="YTDVolume">
                {{ isFromDashboard ? "Rolling 12 Month Volume" : "YTD-Volume" }}
                <p-sortIcon field="YTDVolume"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="YTDVolume"
                  display="menu"></p-columnFilter>
              </th>
              <th *ngIf="!isFromDashboard" pSortableColumn="YTDGPPct">
                YTP-GP% <p-sortIcon field="YTDGPPct"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="YTDGPPct"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="BacklogVolume">
                Backlog Volume <p-sortIcon field="BacklogVolume"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="BacklogVolume"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="BacklogGP">
                Backlog GP <p-sortIcon field="BacklogGP"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="BacklogGP"
                  display="menu"></p-columnFilter>
              </th>
              <th
                pSortableColumn="EstimatedBacklogCommission"
                *ngIf="!isFromDashboard">
                Estimated Backlog Commission
                <p-sortIcon field="EstimatedBacklogCommission"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="EstimatedBacklogCommission"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="CommissionTierDescription">
                {{
                  isFromDashboard
                    ? "Assigned Support Percentage"
                    : "Current Commission Tier"
                }}
                <p-sortIcon field="CommissionTierDescription"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CommissionTierDescription"
                  display="menu"></p-columnFilter>
              </th>
              <th *ngIf="isFromDashboard" pSortableColumn="NextCommissionTier">
                Support % Based Off Numbers
                <p-sortIcon field="NextCommissionTier"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="NextCommissionTier"
                  display="menu"></p-columnFilter>
              </th>
              <th
                pSortableColumn="GPTONextCommissionTier"
                *ngIf="!isFromDashboard">
                {{
                  isFromDashboard
                    ? "GP to Next Support Tier"
                    : "Next To GP Commission"
                }}
                <p-sortIcon field="GPTONextCommissionTier"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="GPTONextCommissionTier"
                  display="menu"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-yearToDateSummaryList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="yearToDateSummaryList"
              [pSelectableRowIndex]="rowIndex">
              <td class="align-left">
                <a
                  (click)="
                    onStackingRedirect(
                      'YTDGP',
                      bcLedgerFilter?.brandingConsultantID || '',
                      bcLedgerFilter?.fromDate || '',
                      bcLedgerFilter?.toDate || '',
                      category
                    )
                  "
                  class="has-link"
                  >{{ yearToDateSummaryList.YTGP | number: "1.2-2" }}</a
                >

                <!-- <a
          class="link-underline"
          [routerLink]="[
            'YTDGP',
            bcLedgerFilter?.brandingConsultantID,
            bcLedgerFilter?.fromDate,
            bcLedgerFilter?.toDate,
            category
          ]"
          >{{ yearToDateSummaryList.YTGP | number: '1.2-2' }}</a 
        >-->
              </td>
              <td class="align-left" *ngIf="isFromDashboard">
                {{ rollingTwelveMonthGp | number: "1.2-2" }}
              </td>
              <td class="align-left">
                <a
                  (click)="
                    onStackingRedirect(
                      'YTDGP',
                      bcLedgerFilter?.brandingConsultantID || '',
                      bcLedgerFilter?.fromDate || '',
                      bcLedgerFilter?.toDate || '',
                      category
                    )
                  "
                  *ngIf="!isFromDashboard"
                  class="has-link"
                  >{{ yearToDateSummaryList.YTDVolume | number: "1.2-2" }}</a
                >
                <!-- <a
          class="link-underline"
          [routerLink]="[
            'YTDGP',
            bcLedgerFilter?.brandingConsultantID,
            bcLedgerFilter?.fromDate,
            bcLedgerFilter?.toDate,
            category
          ]"
          >{{ yearToDateSummaryList.YTDVolume | number: '1.2-2' }}</a
        > -->
                <a
                  (click)="
                    onStackingRedirect(
                      'YTDGP',
                      bcLedgerFilter?.brandingConsultantID || '',
                      bcLedgerFilter?.fromDate || '',
                      bcLedgerFilter?.toDate || '',
                      category
                    )
                  "
                  *ngIf="isFromDashboard"
                  class="has-link"
                  >{{ rollingTwelveMonthRevenue | number: "1.2-2" }}</a
                >
              </td>
              <td class="align-left" *ngIf="!isFromDashboard">
                {{ yearToDateSummaryList.YTDGPPct | number: "1.2-2" }}
              </td>
              <td class="align-left">
                <a
                  (click)="
                    onStackingRedirect(
                      'backlogdetails',
                      bcLedgerFilter?.brandingConsultantID || '',
                      bcLedgerFilter?.fromDate || '',
                      bcLedgerFilter?.toDate || '',
                      category
                    )
                  "
                  class="has-link"
                  >{{
                    yearToDateSummaryList.BacklogVolume | number: "1.2-2"
                  }}</a
                >
                <!-- <a
          class="link-underline"
          [routerLink]="[
            'backlogdetails',
            bcLedgerFilter?.brandingConsultantID,
            bcLedgerFilter?.fromDate,
            bcLedgerFilter?.toDate,
            category
          ]"
          >{{ yearToDateSummaryList.BacklogVolume | number: '1.2-2' }}</a
        > -->
              </td>
              <td class="align-left">
                <a
                  (click)="
                    onStackingRedirect(
                      'backlogdetails',
                      bcLedgerFilter?.brandingConsultantID || '',
                      bcLedgerFilter?.fromDate || '',
                      bcLedgerFilter?.toDate || '',
                      category
                    )
                  "
                  class="has-link"
                  >{{ yearToDateSummaryList.BacklogGP | number: "1.2-2" }}</a
                >
                <!-- <a
          class="link-underline"
          [routerLink]="[
            'backlogdetails',
            bcLedgerFilter?.brandingConsultantID,
            bcLedgerFilter?.fromDate,
            bcLedgerFilter?.toDate,
            category
          ]"
          >{{ yearToDateSummaryList.BacklogGP | number: '1.2-2' }}</a
        > -->
              </td>
              <td class="align-left" *ngIf="!isFromDashboard">
                {{
                  yearToDateSummaryList.EstimatedBacklogCommission
                    | number: "1.2-2"
                }}
              </td>
              <td *ngIf="!isFromDashboard">
                {{ yearToDateSummaryList.CommissionTierDescription }}
              </td>
              <td class="align-left" *ngIf="isFromDashboard">
                {{ currentSupportPercentage | number: "1.2-2" }}
              </td>
              <td class="align-left" *ngIf="isFromDashboard">
                {{ nextCommissionTier | number: "1.2-2" }}%
              </td>
              <td class="align-left" *ngIf="!isFromDashboard">
                {{
                  yearToDateSummaryList.GPTONextCommissionTier | number: "1.2-2"
                }}
              </td>
              <!-- <td class="align-right" *ngIf="isFromDashboard">
        {{ nextToGpCommission | number: '1.2-2' }}
        </td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No year to date summary found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
<jni-modal-stacker
  *ngIf="displayModal"
  [displayModal]="displayModal"
  (closeEvent)="closeBcLedgerModal()">
  <div class="panelBody">
    <jni-ytdgp
      *ngIf="bcLedgerStacker.Path === 'YTDGP'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-ytdgp>
    <jni-backlog-details
      *ngIf="bcLedgerStacker.Path === 'backlogdetails'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-backlog-details>
  </div>
</jni-modal-stacker>
